export const TEXTOS_MARCA_EMPRESA = {
  pt: {
    "Personalizar empresa": "Personalizar empresa",
    "Identidade visual por empresa": "Identidade visual por empresa",
    "Libere cada empresa para usar suas próprias logos e cores no lugar das da plataforma.":
      "Libere cada empresa para usar suas próprias logos e cores no lugar das da plataforma.",
    "Personalização": "Personalização",
    "Identidade visual": "Identidade visual",
    "Ative a personalização de empresas em Aparência Geral para liberar esta função.":
      "Ative a personalização de empresas em Aparência Geral para liberar esta função.",
    "Ative a personalização desta empresa para editar as imagens e cores.":
      "Ative a personalização desta empresa para editar as imagens e cores.",
    "Imagens da Empresa": "Imagens da Empresa",
    "Ícone da Nota Fiscal e dos Pedidos": "Ícone da Nota Fiscal e dos Pedidos",
    "Cores da Empresa": "Cores da Empresa",
    "Paleta de Cores": "Paleta de Cores",
    "Tonalidade da Cor": "Tonalidade da Cor",
    "Intensidade Gradiente do botão": "Intensidade Gradiente do botão",
    "Intensidade da Cor": "Intensidade da Cor",
    "Marca da empresa atualizada.": "Marca da empresa atualizada.",
    "Não foi possível salvar a marca da empresa.": "Não foi possível salvar a marca da empresa.",
    "Não foi possível carregar as empresas.": "Não foi possível carregar as empresas.",
    "Imagem atualizada com sucesso.": "Imagem atualizada com sucesso.",
    "Erro ao enviar imagem.": "Erro ao enviar imagem.",
    "Personalização desta empresa atualizada.": "Personalização desta empresa atualizada.",
    "Não foi possível atualizar a personalização desta empresa.":
      "Não foi possível atualizar a personalização desta empresa.",
    "Imagem removida com sucesso.": "Imagem removida com sucesso.",
    "Erro ao remover imagem.": "Erro ao remover imagem.",
  },
  en: {
    "Personalizar empresa": "Customize company",
    "Identidade visual por empresa": "Company visual identity",
    "Libere cada empresa para usar suas próprias logos e cores no lugar das da plataforma.":
      "Allow each company to use its own logos and colors instead of the platform's.",
    "Personalização": "Customization",
    "Identidade visual": "Visual identity",
    "Ative a personalização de empresas em Aparência Geral para liberar esta função.":
      "Turn on company customization in General Appearance to unlock this feature.",
    "Ative a personalização desta empresa para editar as imagens e cores.":
      "Turn on customization for this company to edit its images and colors.",
    "Imagens da Empresa": "Company Images",
    "Ícone da Nota Fiscal e dos Pedidos": "Invoice and Order Icon",
    "Cores da Empresa": "Company Colors",
    "Paleta de Cores": "Color Palette",
    "Tonalidade da Cor": "Color Shade",
    "Intensidade Gradiente do botão": "Button Gradient Intensity",
    "Intensidade da Cor": "Color Intensity",
    "Marca da empresa atualizada.": "Company brand updated.",
    "Não foi possível salvar a marca da empresa.": "Could not save the company brand.",
    "Não foi possível carregar as empresas.": "Could not load the companies.",
    "Imagem atualizada com sucesso.": "Image updated successfully.",
    "Erro ao enviar imagem.": "Error uploading image.",
    "Personalização desta empresa atualizada.": "This company's customization updated.",
    "Não foi possível atualizar a personalização desta empresa.":
      "Could not update this company's customization.",
    "Imagem removida com sucesso.": "Image removed successfully.",
    "Erro ao remover imagem.": "Error removing image.",
  },
  es: {
    "Personalizar empresa": "Personalizar empresa",
    "Identidade visual por empresa": "Identidad visual por empresa",
    "Libere cada empresa para usar suas próprias logos e cores no lugar das da plataforma.":
      "Permita que cada empresa use sus propios logotipos y colores en lugar de los de la plataforma.",
    "Personalização": "Personalización",
    "Identidade visual": "Identidad visual",
    "Ative a personalização de empresas em Aparência Geral para liberar esta função.":
      "Active la personalización de empresas en Apariencia General para habilitar esta función.",
    "Ative a personalização desta empresa para editar as imagens e cores.":
      "Active la personalización de esta empresa para editar sus imágenes y colores.",
    "Imagens da Empresa": "Imágenes de la Empresa",
    "Ícone da Nota Fiscal e dos Pedidos": "Icono de Facturas y Pedidos",
    "Cores da Empresa": "Colores de la Empresa",
    "Paleta de Cores": "Paleta de Colores",
    "Tonalidade da Cor": "Tonalidad del Color",
    "Intensidade Gradiente do botão": "Intensidad del Gradiente del Botón",
    "Intensidade da Cor": "Intensidad del Color",
    "Marca da empresa atualizada.": "Marca de la empresa actualizada.",
    "Não foi possível salvar a marca da empresa.": "No fue posible guardar la marca de la empresa.",
    "Não foi possível carregar as empresas.": "No fue posible cargar las empresas.",
    "Imagem atualizada com sucesso.": "Imagen actualizada con éxito.",
    "Erro ao enviar imagem.": "Error al enviar la imagen.",
    "Personalização desta empresa atualizada.": "Personalización de esta empresa actualizada.",
    "Não foi possível atualizar a personalização desta empresa.":
      "No fue posible actualizar la personalización de esta empresa.",
    "Imagem removida com sucesso.": "Imagen eliminada con éxito.",
    "Erro ao remover imagem.": "Error al eliminar la imagen.",
  },
  "zh-CN": {
    "Personalizar empresa": "自定义企业",
    "Identidade visual por empresa": "企业视觉识别",
    "Libere cada empresa para usar suas próprias logos e cores no lugar das da plataforma.":
      "允许每个企业使用自己的徽标和颜色,而不是平台的。",
    "Personalização": "自定义",
    "Identidade visual": "视觉识别",
    "Ative a personalização de empresas em Aparência Geral para liberar esta função.":
      "在“整体外观”中开启企业自定义以解锁此功能。",
    "Ative a personalização desta empresa para editar as imagens e cores.":
      "开启此企业的自定义以编辑其图片和颜色。",
    "Imagens da Empresa": "企业图片",
    "Ícone da Nota Fiscal e dos Pedidos": "发票和订单图标",
    "Cores da Empresa": "企业颜色",
    "Paleta de Cores": "调色板",
    "Tonalidade da Cor": "颜色色调",
    "Intensidade Gradiente do botão": "按钮渐变强度",
    "Intensidade da Cor": "颜色强度",
    "Marca da empresa atualizada.": "企业品牌已更新。",
    "Não foi possível salvar a marca da empresa.": "无法保存企业品牌。",
    "Não foi possível carregar as empresas.": "无法加载企业列表。",
    "Imagem atualizada com sucesso.": "图片更新成功。",
    "Erro ao enviar imagem.": "上传图片时出错。",
    "Personalização desta empresa atualizada.": "该企业的自定义设置已更新。",
    "Não foi possível atualizar a personalização desta empresa.": "无法更新该企业的自定义设置。",
    "Imagem removida com sucesso.": "图片删除成功。",
    "Erro ao remover imagem.": "删除图片时出错。",
  },
};
